import React from "react";
import { useContext } from "react";
import { VideosPopupContext } from "./VideosPopupContext";
import "./VideosPreview.css";

function VideosPreview({ video, index }) {
 
    const { openPopup } = useContext(VideosPopupContext)
    console.log(`props are ${video.Id} ${video.Title} ${video.TmageUrl} ${video.Description}`)
    console.log(`index is ${index}`)
    
    return(
        
        <div key={`video-preview-${video.Id}`} onClick={() => openPopup(video.Id, video.Title, video.TmageUrl, video.Description)} className="videos-preview videos-about__item_video_block-all" style={{ marginBottom: "5%"}} >
            <h3 className="videos-about__item_head">{video.Title}</h3>
            <div className="videos-about__item_video_block">
                <img src={video.ImageUrl} alt="video"></img>
             </div>
        </div>
    )
}

export {VideosPreview}